module.exports = __webpack_public_path__ + "img/nfc-round.50bf03ae.svg";